import { appBus } from "@src/features/events";
import { useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";

/**
 * Bridges React Router's context into the app event bus.
 *
 * Route params and search params are only accessible inside the React tree.
 * This component sits at the root and re-emits them onto `appBus` whenever
 * they change, so the encounter actor and patient store — which live outside
 * React — can react to navigation without needing their own router hooks.
 *
 * @example
 * <RouterBridge />
 * <App />
 */
export const RouterBridge = () => {
  const [searchParams] = useSearchParams();
  const { patientId, encounterId } = useParams();

  useEffect(() => {
    appBus.emit("client.router_params_changed", {
      params: { patientId, encounterId },
    });
  }, [patientId, encounterId]);

  useEffect(() => {
    appBus.emit("client.router_search_params_changed", { searchParams });
  }, [searchParams]);

  return null;
};
